export default function WhyUs() {
  const reasons = [
    {
      icon: 'ri-shield-check-line',
      title: 'AI-Based Guarantee',
      description: 'We base expenses on accurate models, not guesses. Artificial intelligence analyzes millions of data points to make optimal decisions.',
      color: 'from-blue-500 to-cyan-500'
    },
    {
      icon: 'ri-rocket-line',
      title: 'Secret Weapon',
      description: 'Technologies that your competitors don\'t have. We use advanced AI tools for forecasting and automation.',
      color: 'from-purple-500 to-pink-500'
    },
    {
      icon: 'ri-time-line',
      title: 'Your Time is Valuable',
      description: 'We take care of the routine, you focus on business. Complete process automation frees up your resources for strategic development.',
      color: 'from-orange-500 to-red-500'
    }
  ];

  return (
    <section className="py-24 bg-gradient-to-b from-slate-50 to-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-slate-900 mb-6">
            Why Us?
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            We are your strategic partner, not just a contractor
          </p>
        </div>

        <div className="grid lg:grid-cols-3 gap-8 mb-16">
          {reasons.map((reason, index) => (
            <div 
              key={index}
              className="bg-white rounded-2xl shadow-xl overflow-hidden hover:shadow-2xl transition-all duration-300 group"
            >
              <div className={`bg-gradient-to-br ${reason.color} p-8 text-white h-48 flex items-center justify-center`}>
                <div className="w-24 h-24 bg-white/20 backdrop-blur-sm rounded-full flex items-center justify-center group-hover:scale-110 transition-transform duration-300">
                  <i className={`${reason.icon} text-6xl`}></i>
                </div>
              </div>
              
              <div className="p-8">
                <h3 className="text-2xl font-bold text-slate-900 mb-4">
                  {reason.title}
                </h3>
                <p className="text-gray-700 leading-relaxed">
                  {reason.description}
                </p>
              </div>
            </div>
          ))}
        </div>

        <div className="bg-gradient-to-br from-slate-900 to-blue-900 rounded-3xl p-12 text-center shadow-2xl">
          <div className="max-w-4xl mx-auto">
            <h3 className="text-3xl md:text-4xl font-bold text-white mb-6">
              We Don't Just Do Advertising
            </h3>
            <p className="text-xl text-gray-300 leading-relaxed mb-8">
              We are building a system that works for you 24/7, is constantly being optimized and scaled. Our goal is to make your marketing autonomous and predictable.
            </p>
            <div className="grid md:grid-cols-3 gap-8 mt-12">
              <div className="bg-white/10 backdrop-blur-sm rounded-xl p-6">
                <div className="text-4xl font-bold text-cyan-400 mb-2">35+</div>
                <div className="text-gray-300">Successful Projects</div>
              </div>
              <div className="bg-white/10 backdrop-blur-sm rounded-xl p-6">
                <div className="text-4xl font-bold text-cyan-400 mb-2">x3.5</div>
                <div className="text-gray-300">Average Sales Growth</div>
              </div>
              <div className="bg-white/10 backdrop-blur-sm rounded-xl p-6">
                <div className="text-4xl font-bold text-cyan-400 mb-2">85%</div>
                <div className="text-gray-300">Satisfied Clients</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}